import http from '@/requests/http'

class MessageCategory {
  static all (params) {
    return http.post('messages/category', params)
  }
  static store (params) {
    return http.post('messages/category/store', params)
  }
  static view (params) {
    return http.post('messages/category/view', params)
  }
  static update (params) {
    return http.post('messages/category/update', params)
  }
  static destroy (params) {
    return http.post('messages/category/destroy', params)
  }
}

export default MessageCategory
